import { InjectionToken } from '@angular/core';
import { PpHttpConfig } from '@penpencil/common';
export const PEN_PENCIL_FORMS_API_CONFIG = new InjectionToken<PpHttpConfig>(
  'PEN_PENCIL_FORMS_API_CONFIG',
);
export const MAX_IMAGE_SIZE = 2;
export const SELECT_SEARCH_DEFAULT_DEBOUNCE_WAIT = 500;
